import PatientEditDialog from './PatientEditDialog.view';

export default PatientEditDialog;
